type Variant = {
  variantId: string | null;
  variantName: string;
  price: number | string;
  stock: number | string;
};

type InventoryItem = {
  description: string | null;
  itemId: string;
  name: string;
  images: any;
  variants?: Variant[]; // now optional to support add-ons
  isAddon?: boolean; // flag to identify if this is an addon
  stock?: any;
};

type BillingCardProps = {
  item: InventoryItem;
  onClick: (item: InventoryItem, variant?: Variant) => void;
};

export default function BillingCard({ item, onClick }: BillingCardProps) {
  const getStockPercentage = (stock: number | string) => {
    const stockLevel = typeof stock === "number" ? stock : parseInt(stock);
    return Math.min(Math.max(stockLevel, 0), 100);
  };

  // If item has no variants, treat it as an add-on
  if (!item.variants || item.variants.length === 0) {
    const stock =
      typeof item.stock === "number" ? item.stock : parseInt(item.stock);
    const stockPercentage = stock >= 0 ? getStockPercentage(stock) : 0;
    const isOutOfStock = stock <= 0;

    return (
      <div
        className="border p-4 rounded shadow cursor-pointer hover:bg-gray-100 flex justify-between items-center"
        onClick={() => onClick(item)}
      >
        <div className="flex flex-col">
          <p className="text-sm font-medium">
            {item.name} — ₹{(item as any).price}
          </p>

          <div className="mt-2">
            <div className="text-xs font-semibold">
              Stock: {isOutOfStock ? "Out of stock" : `${item.stock} left`}
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1">
              <div
                className="h-2.5 rounded-full"
                style={{
                  width: `${stockPercentage}%`,
                  backgroundColor: isOutOfStock
                    ? "red"
                    : stockPercentage > 50
                    ? "green"
                    : stockPercentage > 20
                    ? "orange"
                    : "red",
                }}
              ></div>
            </div>

            {isOutOfStock && (
              <div className="text-red-500 text-xs mt-1">
                Note: This item is out of stock.
              </div>
            )}
          </div>
        </div>
        <button className="text-green-600 text-sm">Add</button>
      </div>
    );
  }

  // If item has variants, render as inventory item
  return (
    <div className="border p-4 rounded shadow">
      {item.images && item.images[0]?.url && (
        <img
          src={item.images[0].url}
          alt={item.name}
          className="w-20 h-20 object-cover mb-2 rounded"
        />
      )}

      <h3 className="font-medium">{item.name}</h3>
      <p className="text-sm text-gray-600">{item.description}</p>
      <div className="space-y-1 mt-2">
        {item.variants.map((variant) => {
          const stock =
            typeof variant.stock === "number"
              ? variant.stock
              : parseInt(variant.stock);
          const stockPercentage = stock >= 0 ? getStockPercentage(stock) : 0;
          const isOutOfStock = stock <= 0;

          return (
            <div
              key={variant.variantId}
              className="border px-2 py-1 rounded cursor-pointer hover:bg-gray-100 flex justify-between items-center"
              onClick={() => onClick(item, variant)}
            >
              <div className="flex flex-col">
                <p className="text-sm font-medium">
                  {variant.variantName} — ₹{variant.price}
                </p>

                <div className="mt-2">
                  <div className="text-xs font-semibold">
                    Stock:{" "}
                    {isOutOfStock ? "Out of stock" : `${variant.stock} left`}
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1">
                    <div
                      className="h-2.5 rounded-full"
                      style={{
                        width: `${stockPercentage}%`,
                        backgroundColor: isOutOfStock
                          ? "red"
                          : stockPercentage > 50
                          ? "green"
                          : stockPercentage > 20
                          ? "orange"
                          : "red",
                      }}
                    ></div>
                  </div>

                  {isOutOfStock && (
                    <div className="text-red-500 text-xs mt-1">
                      Note: This item is out of stock.
                    </div>
                  )}
                </div>
              </div>

              <button
                className="text-green-600 text-sm"
                // disabled={isOutOfStock}
              >
                {"Add"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
